export enum VenueType {
  CLUB = 'CLUB',
  LOUNGE = 'LOUNGE',
  EVENT_SPACE = 'EVENT_SPACE',
  BAR = 'BAR',
  FESTIVAL = 'FESTIVAL',
}

export enum VenueTypeName {
  CLUB = 'Club',
  LOUNGE = 'Lounge',
  EVENT_SPACE = 'Event Space',
  BAR = 'Bar',
  FESTIVAL = 'Festival',
}

export const venueScheduleTimeRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/

export enum VenueAction {
  SYNC_TABLE_QUANTITY = 'SYNC_TABLE_QUANTITY',
  SYNC_SUBSCRIPTION = 'SYNC_SUBSCRIPTION',
}

export enum VenuePosType {
  OMNIVORE = 'OMNIVORE',
  SILVERWARE = 'SILVERWARE',
  TOAST = 'TOAST',
  SQUARE = 'SQUARE',
}

export enum VenueVisibility {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC',
  PUBLISHED = 'PUBLISHED',
}

export enum VenueVisibilityValue {
  /**
   * @description Private access, only visible direct links
   */
  PRIVATE = 0,
  /**
   * @description Public access, visible to everyone
   */
  PUBLIC = 10,
  /**
   * @description Publish to any integrations (Tablelist, Website, etc)
   */
  PUBLISHED = 20,
}

export enum VenueVisibilityName {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC',
  PUBLISHED = 'PUBLISHED',
}

export const venueVisibilityValueToName = {
  [VenueVisibilityValue.PRIVATE]: VenueVisibilityName.PRIVATE,
  [VenueVisibilityValue.PUBLIC]: VenueVisibilityName.PUBLIC,
  [VenueVisibilityValue.PUBLISHED]: VenueVisibilityName.PUBLISHED,
}

export const venueVisibilityNameToValue = {
  [VenueVisibilityName.PRIVATE]: VenueVisibilityValue.PRIVATE,
  [VenueVisibilityName.PUBLIC]: VenueVisibilityValue.PUBLIC,
  [VenueVisibilityName.PUBLISHED]: VenueVisibilityValue.PUBLISHED,
}

export enum VenueSubscriptionStatus {
  FUTURE = 'FUTURE',
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
  CANCEL_PENDING = 'CANCEL_PENDING',
  PAST_DUE = 'PAST_DUE',
  CANCELLED = 'CANCELLED',
}

export enum VenueSubscriptionStatusName {
  FUTURE = 'Future',
  INACTIVE = 'Inactive',
  ACTIVE = 'Active',
  CANCEL_PENDING = 'Cancel Pending',
  PAST_DUE = 'Past Due',
  CANCELLED = 'Canceled',
}

export enum VenueSubscriptionPlan {
  PLAN_1 = 'PLAN_1',
  PLAN_2 = 'PLAN_2',
}

export enum VenueSubscriptionPlanName {
  PLAN_1 = 'Plan 1',
  PLAN_2 = 'Plan 2',
}

export enum VenueInventorySortOrder {
  PRICE_LOW_TO_HIGH = 'PRICE_LOW_TO_HIGH',
  PRICE_HIGH_TO_LOW = 'PRICE_HIGH_TO_LOW',
  ALPHABETICAL = 'ALPHABETICAL',
}

export enum VenueInventorySortOrderName {
  PRICE_LOW_TO_HIGH = 'Price - Low to high',
  PRICE_HIGH_TO_LOW = 'Price - High to low',
  ALPHABETICAL = 'Alphabetical',
}

export enum DateDisplayFormat {
  MM_DD_YYYY = 'MM/DD/YYYY',
  DD_MM_YYYY = 'DD/MM/YYYY',
}

export enum VenueEvent {
  CREATED = 'TL_VENUE_CREATED',
  UPDATED = 'TL_VENUE_UPDATED',
  FRONTEND_VERSION_UPDATED = 'TL_VENUE_FRONTEND_VERSION_UPDATED',
  ZOHO_SYNC = 'TL_VENUE_ZOHO_SYNC',
  SUBSCRIPTION_UPDATED = 'TL_VENUE_SUBSCRIPTION_UPDATED',
  SUBSCRIPTION_DOWNGRADED = 'TL_VENUE_SUBSCRIPTION_DOWNGRADED',
  SUBSCRIPTION_UPGRADED = 'TL_VENUE_SUBSCRIPTION_UPGRADED',
  TIMEZONE_UPDATED = 'TL_VENUE_TIMEZONE_UPDATED',
}

export enum VenueSort {
  NAME = 'name',
  NAME_DESC = '-name',
}

export enum VenueFrontendVersion {
  STABLE = 'stable',
  NEXT = 'next',
}

export enum StripeConnectType {
  STANDARD = 'standard',
  EXPRESS = 'express',
}

export const STRIPE_APPLICATION_FEE_BLOCKED_COUNTRIES = [
  'MX',
  'BR',
  'IN',
  'MY',
  'SG',
  'TH',
] as const

export const venueAdminOnlyKeys = [
  'reservation',
  'visibility',
  'hidden',
  'accessLevel',
  'isUnderReview',
  'isLocked',
  'isPastDue',
  'isSellingApproved',
  'tableProcessingFee',
  'ticketProcessingFee',
  'ticketCommissionDirect',
  'ticketCommissionIndirect',
  'tableCommissionDirect',
  'tableCommissionIndirect',
  'stripeConnectEnabled',
  'paymentProviderAccountId',
  'stripeConnectType',
  'stripeAccountCountry',
  'subscriptionPrivelages',
  'subscriptionAddOns',
  'subscriptionStatus',
  'subscriptionPlan',
  'isPayingNonSubscribed',
  'payingParentVenueId',
  'posLocationId',
  'customerChatPhoneNumber',
  'customerChatEmailAddress',
  'buyFrontendVersion',
  'venga',
  'slug',
]

export enum VenueTagType {
  USER_DEFINED = 'USER_DEFINED',
  AMBIENCE = 'AMBIENCE',
  CROWD = 'CROWD',
  DRESS_CODE_OK = 'DRESS_CODE_OK',
  DRESS_CODE_NOT_OK = 'DRESS_CODE_NOT_OK',
  FEATURES = 'FEATURES',
  GOOD_FOR = 'GOOD_FOR',
  MUSIC = 'MUSIC',
  NOISE_LEVELS = 'NOISE_LEVELS',
  BUSY_NIGHTS = 'BUSY_NIGHTS',
  VENUE_SUB_TYPE = 'VENUE_SUB_TYPE',
}

export const venueSlugMinLength = 1
export const venueSlugMaxLength = 255

/** Sentinel `cityId` for listing venues with no assigned city. */
export const VENUE_LIST_CITY_UNSET = 'none'

export const VENUE_LIST_HEALTH_SCORE_ZERO = '0'
export const VENUE_LIST_HEALTH_SCORE_POSITIVE = 'gt0'

export const venueDefaultBranding = {
  primaryColor: {
    red: 162,
    green: 58,
    blue: 255,
  },
  secondaryColor: {
    red: 95,
    green: 97,
    blue: 97,
  },
  theme: 'dark' as const,
}
